import { type FieldValues, useController } from 'react-hook-form';

import { Icon } from '~/components';
import type { FormFieldInputProps } from '~/components/FormField';
import { FormField } from '~/components/FormField';
import { Input } from '~/components/Input';
import { toValidUrl } from '~/modules/settings/utils/helpers';

function FormFieldLinkInput<TFieldValues extends FieldValues>({
  name,
  label,
  className,
  disabled = false,
  readOnly = false,
  ...inputProps
}: FormFieldInputProps<TFieldValues> & { className?: string }) {
  const {
    field,
    fieldState: { invalid },
  } = useController({ name, disabled });

  const validUrl = toValidUrl(field.value);

  return (
    <FormField
      name={name}
      label={label}
      className={className}
      disabled={disabled}
      readOnly={readOnly}
    >
      <div className="relative">
        <Input
          id={name}
          {...field}
          state={invalid ? 'error' : undefined}
          {...inputProps}
          disabled={disabled}
          readOnly={readOnly}
          className="pr-2xl"
        />
        {validUrl ? (
          <a
            href={validUrl}
            target="_blank"
            className="absolute right-md top-1/2 -translate-y-1/2"
          >
            <Icon type="up-right-from-square" size="sm" />
          </a>
        ) : null}
      </div>
    </FormField>
  );
}

FormFieldLinkInput.displayName = 'FormFieldLinkInput';

export { FormFieldLinkInput };
